import api, { apiInternal } from '../api';

export async function getParticipantsByEstaId(estaId) {
  const { data } = await api.post(`${apiInternal}/establishment/params/getParticipants`, { esta_id: estaId });  
  return data;
}

export async function getParticipantById(estaId, Id) {
  const { data } = await api.post(`${apiInternal}/participant/detail`, { esta_id: estaId, par_id: Id });
  return data;
}

export async function setParticipant(  participant) {
  const { data } = await api.post(`${apiInternal}/participant/update`, participant );
  return data;

}

export async function getMappedParticipants(estaId, cntId) {
  const {data } = await api.post(`${apiInternal}/establishment/params/GetMappedParticipants`, { esta_id: estaId, cnt_id: cntId });
  return data;
}

export async function setMappingParticipant(params) {
  const {data} = await api.post(`${apiInternal}/participant/SetMappingParticipant`, params);
  return data;
}